import React from 'react';
import './SoloGames.css';

const SOLO_GAMES = [
  {
    id: 'cryptoflip',
    name: 'QUANTUM COIN CRUSADER',
    nameClass: 'legendary',
    description: 'Master the ancient art of quantum probability warfare - Double or nothing in the ultimate heads vs tails battleground',
    icon: '🪙',
    type: 'contract',
    status: 'active',
    themeClass: 'ocean-theme', // Ocean theme for game 1
    battleInfo: {
      minStake: '1 BLB',
      maxStake: '1M BLB',
      arenaFee: '5%',
      victoryMultiplier: '1.95x',
      difficultyLevel: 'CHAMPION',
      battleType: 'Probability Warfare',
      winRate: '47.5%',
      avgBattleTime: '15s'
    }
  },

  {
    id: 'SpinWheel',
    name: 'COSMIC FORTUNE SPINNER',
    nameClass: 'mythic',
    description: 'Harness celestial forces to spin the wheel of cosmic destiny - 35 sectors of pure adrenaline and massive rewards',
    icon: '🎰',
    type: 'contract',
    status: 'active',
    themeClass: 'desert-theme', // Desert theme for game 2
    battleInfo: {
      minStake: '5 BLB',
      maxStake: '2M BLB',
      arenaFee: '2.7%',
      victoryMultiplier: '35x',
      difficultyLevel: 'LEGENDARY',
      battleType: 'Cosmic Gambling',
      winRate: '2.86%',
      avgBattleTime: '30s'
    }
  },

  {
    id: 'LuckyDice',
    name: 'INFERNAL DICE DOMINATOR',
    nameClass: 'epic',
    description: 'Command the sacred dice of the underworld - Roll your way to glory in this high-stakes probability arena',
    icon: '🎲',
    type: 'contract',
    status: 'active',
    themeClass: 'forest-theme', // Forest theme for game 3
    battleInfo: {
      minStake: '2 BLB',
      maxStake: '500K BLB',
      arenaFee: '4%',
      victoryMultiplier: '2.1x',
      difficultyLevel: 'VETERAN',
      battleType: 'Sacred Ritual',
      winRate: '45.7%',
      avgBattleTime: '20s'
    }
  },

  {
    id: 'CryptoSlots',
    name: 'NEON JACKPOT BLASTER',
    nameClass: 'mythic',
    description: 'Enter the cyberpunk slot dimension where digital reels determine your fate - Triple sevens unlock infinite power',
    icon: '🎰',
    type: 'contract',
    status: 'active',
    themeClass: 'arctic-theme', // Arctic theme for game 4
    battleInfo: {
      minStake: '10 BLB',
      maxStake: '5M BLB',
      arenaFee: '3.5%',
      victoryMultiplier: '777x',
      difficultyLevel: 'MYTHICAL',
      battleType: 'Digital Chaos',
      winRate: '0.13%',
      avgBattleTime: '45s'
    }
  },

  {
    id: 'CrystalBallFortune',
    name: 'MYSTIC CRYSTAL PROPHET',
    nameClass: 'legendary',
    description: 'Peer into the ethereal crystal sphere and unlock the secrets of future fortune - Ancient magic meets modern gaming',
    icon: '🔮',
    type: 'contract',
    status: 'active',
    themeClass: 'space-theme', // Space theme for game 5
    battleInfo: {
      minStake: '3 BLB',
      maxStake: '750K BLB',
      arenaFee: '3.8%',
      victoryMultiplier: '3.5x',
      difficultyLevel: 'MYSTIC',
      battleType: 'Fortune Telling',
      winRate: '28.6%',
      avgBattleTime: '25s'
    }
  },

  {
    id: 'NumberBlast',
    name: 'DIGITAL MATRIX BREAKER',
    nameClass: 'epic',
    description: 'Hack the numerical matrix and exploit system vulnerabilities - Pure mathematics meets explosive action',
    icon: '💥',
    type: 'contract',
    status: 'active',
    themeClass: 'cave-theme', // Cave theme for game 6
    battleInfo: {
      minStake: '1 BLB',
      maxStake: '300K BLB',
      arenaFee: '4.2%',
      victoryMultiplier: '2.8x',
      difficultyLevel: 'HACKER',
      battleType: 'Code Breaking',
      winRate: '35.7%',
      avgBattleTime: '35s'
    }
  },

  {
    id: 'HiLoCards',
    name: 'SHADOW CARD ASSASSIN',
    nameClass: 'legendary',
    description: 'Master the deadly art of card prediction warfare - Higher or lower, every choice could be your last',
    icon: '🃏',
    type: 'contract',
    status: 'active',
    themeClass: 'sky-theme', // Sky theme for game 7
    battleInfo: {
      minStake: '2 BLB',
      maxStake: '1M BLB',
      arenaFee: '3.2%',
      victoryMultiplier: '1.85x',
      difficultyLevel: 'ASSASSIN',
      battleType: 'Card Mastery',
      winRate: '51.4%',
      avgBattleTime: '40s'
    }
  },

  {
    id: 'BullsEye',
    name: 'PLASMA TARGET ANNIHILATOR',
    nameClass: 'epic',
    description: 'Unleash precision destruction on plasma targets - Every shot counts in this high-energy marksmanship arena',
    icon: '🎯',
    type: 'contract',
    status: 'active',
    themeClass: 'jungle-theme', // Jungle theme for game 8
    battleInfo: {
      minStake: '5 BLB',
      maxStake: '800K BLB',
      arenaFee: '4.5%',
      victoryMultiplier: '4.2x',
      difficultyLevel: 'MARKSMAN',
      battleType: 'Precision Combat',
      winRate: '23.8%',
      avgBattleTime: '60s'
    }
  },

  {
    id: 'SpaceMission',
    name: 'GALACTIC WARP COMMANDER',
    nameClass: 'mythic',
    description: 'Navigate through hostile cosmic territories and asteroid fields - Command your starship to victory or perish in the void',
    icon: '🚀',
    type: 'contract',
    status: 'active',
    themeClass: 'electric-theme', // Electric theme for game 9
    battleInfo: {
      minStake: '8 BLB',
      maxStake: '2M BLB',
      arenaFee: '3.8%',
      victoryMultiplier: '6.5x',
      difficultyLevel: 'COMMANDER',
      battleType: 'Space Warfare',
      winRate: '15.4%',
      avgBattleTime: '90s'
    }
  },

  {
    id: 'CryptoBlackjack',
    name: 'QUANTUM BLACKJACK OVERLORD',
    nameClass: 'legendary',
    description: 'Dominate the quantum blackjack dimension where 21 is the key to infinite wealth - Beat the dealer or face digital oblivion',
    icon: '🂡',
    type: 'contract',
    status: 'active',
    themeClass: 'cyberpunk-theme', // Cyberpunk theme for game 10
    battleInfo: {
      minStake: '10 BLB',
      maxStake: '3M BLB',
      arenaFee: '2.5%',
      victoryMultiplier: '2.0x',
      difficultyLevel: 'OVERLORD',
      battleType: 'Quantum Cards',
      winRate: '48.5%',
      avgBattleTime: '75s'
    }
  }
];

const SoloGames = ({ onNavigate }) => {
  return (
    <div className="solo-games-container">
      <div className="solo-games-grid">
        {SOLO_GAMES.map((game) => (
          <div 
            key={game.id}
            className={`solo-game-card ${game.status} ${game.themeClass}`}
            onClick={() => game.status === 'active' && onNavigate(game.id)}
          >
            <div className="game-header">
              <div className="game-icon-section">
                <div className="game-icon">{game.icon}</div>
              </div>
              <div className="game-status-indicator">
                <div className={`status-dot ${game.status}`}></div>
                <span className="status-text">
                  {game.status === 'active' ? 'COMBAT READY' : 'INITIALIZING'}
                </span>
              </div>
            </div>
            
            <div className="game-info">
              <h3 className={`game-title ${game.nameClass}`}>{game.name}</h3>
              <p className="game-description">{game.description}</p>
            </div>

            <div className="game-stats">
              <div className="stat-row">
                <span className="stat-label">MIN DEPLOYMENT</span>
                <span className="stat-value">{game.battleInfo.minStake}</span>
              </div>
              <div className="stat-row">
                <span className="stat-label">MAX DEPLOYMENT</span>
                <span className="stat-value">{game.battleInfo.maxStake}</span>
              </div>
              <div className="stat-row">
                <span className="stat-label">VICTORY BONUS</span>
                <span className="stat-value">{game.battleInfo.victoryMultiplier}</span>
              </div>
              <div className="stat-row">
                <span className="stat-label">BATTLE TAX</span>
                <span className="stat-value">{game.battleInfo.arenaFee}</span>
              </div>
              <div className="stat-row">
                <span className="stat-label">SUCCESS RATE</span>
                <span className="stat-value">{game.battleInfo.winRate}</span>
              </div>
              <div className="stat-row">
                <span className="stat-label">COMBAT TIME</span>
                <span className="stat-value">{game.battleInfo.avgBattleTime}</span>
              </div>
            </div>

            <div className="game-footer">
              <div className="difficulty-badge">
                <span className="difficulty-level">{game.battleInfo.difficultyLevel}</span>
                <span className="difficulty-type">{game.battleInfo.battleType}</span>
              </div>
              
              <button className={`engage-button ${game.status}`}>
                {game.status === 'active' ? 'DEPLOY' : 'STANDBY'}
              </button>
            </div>

            <div className="reward-indicator">
              <span>⚡ COMBAT REWARDS</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SoloGames;